import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import './DueDateSchedule.css'

const DueDateScheduleUI = ({ totalUnpaid, priorDueLoanRepaymentList }) =>
  <CardUI title='Overdues Unpaid' className='g_m_top_100 c_table_unpaid'>
    <table>
      <thead>
        <tr>
          <th />
          <th>Account/Loan</th>
          <th>Scheduled Date</th>
          <th>EMI</th>
          <th>Dsra Dip Interest</th>
          <th>Penal Charge</th>
        </tr>
      </thead>
      <tbody>
        {
          priorDueLoanRepaymentList && priorDueLoanRepaymentList.map((repayment, i) =>
            <tr>
              <td>{i + 1}</td>
              <td>{repayment.accountName}<br/>
                <Link to={`/su/loans/${repayment.loanId}/repayments`}>
                  {repayment.loanName}
                </Link>
              </td>
              <td>{repayment.scheduledDateF1}</td>
              <td className='g_text_right'>
                <span className='g_flex_v'>
                  {repayment.emiDueAmountF5}
                </span>
              </td>
              <td className='g_text_right'>
                <span className='g_flex_v'>
                  {repayment.dsraDipInterestDueAmountF5}
                </span>
              </td>
              <td className='g_text_right'>
                <span className='g_flex_v'>
                  {repayment.defaultInterestDueAmountF5}
                </span>
              </td>
            </tr>
          )
        }
        <tr>
          <td />
          <td><b>Subtotal</b></td>
          <td />
          <td className='g_text_right'><b>{totalUnpaid.totalEMIDueF5}</b></td>
          <td className='g_text_right'><b>{totalUnpaid.totalDSRADipInterestDueF5}</b></td>
          <td className='g_text_right'><b>{totalUnpaid.totalDefaultInterestDueF5}</b></td>
        </tr>
      </tbody>
    </table>

    <div className='g_m_top_50'>
      <span className='g_m_left_50'><b>Total: {totalUnpaid.totalPriorDueF5}</b></span>
    </div>
  </CardUI>

export default DueDateScheduleUI
